export default "__VITE_ASSET__zcN6mFve__"